import React from "react";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";

import { Button } from "components";
import { FormColumn, FormRow } from "components/layout";

type FormActionsProps = {
	isLoading: boolean;
	className: string;
};

export const FormActions = ({ isLoading, className }: FormActionsProps) => {
	const { formState } = useFormContext();
	return (
		<FormRow className={clsx("mt-2", className)}>
			<FormColumn>
				<Button
					type="submit"
					disabled={!formState.isDirty}
					value="Save"
					isLoading={isLoading}
				/>
			</FormColumn>
		</FormRow>
	);
};
